// import { getPermissions, getUserId } from "@/utils/indexDb/permissionStore";
// import { mapIncomingPermissions } from "@/utils/permission/permissionFormatter";
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getPermissions, getUserId } from "../utils/IndexDB/PermissionStore";

const PermissionContext = createContext(null);

export const PermissionProvider = ({ modules, children }) => {
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadPermissions = useCallback(async () => {
        try {
            setLoading(true);
            const userId = await getUserId();
            if (!userId) {
                if(window.location.hash == '#/admin-login'){
                      toast.warn("Session expired. Please log in again.");
                }
                setPermissions([]);
                setLoading(false);
                return;
            }

            const permissionRes = await getPermissions(userId);

            // const formatted = mapIncomingPermissions(permissionRes, modules);
            setPermissions(permissionRes);
            setLoading(false);
        } catch (err) {
            console.log("Permission loading error:", err);
            setLoading(false);
        }
    }, [modules]);

    useEffect(() => {
        loadPermissions();
    }, [loadPermissions]);

    // Look-up helpers
    const getModule = (name) => {
        return permissions.find(
            (p) => p.moduleName?.toLowerCase() === name?.toLowerCase()
        );
    };

    const canView = (module) => !!getModule(module)?.viewOnly || !!getModule(module)?.viewAll;
    const canViewAll = (module) => !!getModule(module)?.viewAll;
    const canAdd = (module) => !!getModule(module)?.add;
    const canEdit = (module) => !!getModule(module)?.modifyOnly;
    const canDelete = (module) => !!getModule(module)?.delete;
    const canImport = (module) => !!getModule(module)?.import;
    const canExport = (module) => !!getModule(module)?.export;
    const canFullAccess = (module) => !!getModule(module)?.fullAccess;

    return (
        <PermissionContext.Provider
            value={{
                permissions,
                loading,
                refreshPermissions: loadPermissions,
                canView,
                canViewAll,
                canAdd,
                canEdit,
                canDelete,
                canImport,
                canExport,
                canFullAccess
            }}
        >
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermission = () => useContext(PermissionContext);
